import { createContext } from 'react';

export type BlockingLoaderService = {
  show: () => void; // increment the active-request counter
  hide: () => void; // decrement, floored at 0
  reset: () => void; // clear the counter (session-expiry path: swallowed requests never reach their finally)
};

export const LoaderContext = createContext<BlockingLoaderService | null>(null);

// Visibility lives in its own context so the []-memoized service above never rebuilds: consumers that
// only call show/hide/reset (ClientLoginProvider, every fetch hook) don't re-render on loader flips —
// only the rare consumer that actually renders from visibility subscribes to this one.
export const LoaderVisibilityContext = createContext<boolean | null>(null);
